var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-multiple-choice-checkbox tw-text-center",class:[
    _vm.selected ? 'tw-bg-primary tw-text-white' : 'tw-bg-gray-300',
    _vm.singleAnswer ? 'tw-rounded-full' : 'tw-rounded' ]},[(_vm.selected)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }